import React from "react";
import { CSVLink } from "react-csv";
import { Table } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

function generateCSVDataAccount(seriesData) {
  return seriesData.map((entry) => ({
    "Exchange Instrument": entry.exchangeInstrument,
    Account: entry.tradeAccount,
    Action: entry.action,
    "Action At": new Date(entry.timestamp).toLocaleString(),
  }));
}

const AccountEventLogsTable = ({ eventLogs }) => {
  const columns = [
    { title: "Exchange Instrument", dataIndex: "exchangeInstrument", key: "exchangeInstrument" },
    { title: "Account", dataIndex: "tradeAccount", key: "tradeAccount" },
    { title: "Action", dataIndex: "action", key: "action" },
    {
      title: "Action At",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (timestamp) => new Date(timestamp).toLocaleString(),
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
    },
  ];

  const csvData = generateCSVDataAccount(eventLogs);

  return (
    <>
      <CSVLink data={csvData} filename={`AccountEventLogs-${new Date().toISOString()}.csv`} separator=";">
        <DownloadOutlined style={{ marginRight: 5 }} />
        Download csv
      </CSVLink>
      <Table rowKey="timestamp" bordered dataSource={eventLogs} columns={columns} pagination={{ pageSize: 10 }} />
    </>
  );
};

export default AccountEventLogsTable;
